import Vue from 'vue';

export const fncSpinePriceList = ( { commit, state, rootState }, payload ) => {
	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			var objAuthorize = JSON.parse( rootState.objAuthorize );			
			var pricelistDetails = {token: data.token, manufacturer_id: objAuthorize.manufacturer};			
			Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {					
				commit('fncSetSpinePriceList', data);
			});
		});
}
